import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ clients }) => {
  const totalClients = clients.length;
  const activeClients = clients.filter(client => client.balance > 0).length;
  const totalMinutes = clients.reduce((sum, client) => sum + client.balance, 0);
  const lowBalanceClients = clients.filter(client => client.balance > 0 && client.balance <= 30).length;

  const stats = [
    {
      id: 'total',
      label: 'Total Clients',
      value: totalClients,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'active',
      label: 'Active Clients',
      value: activeClients,
      icon: 'UserCheck',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      id: 'minutes',
      label: 'Total Minutes',
      value: totalMinutes.toLocaleString(),
      icon: 'Clock',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'low',
      label: 'Low Balance',
      value: lowBalanceClients,
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => (
        <div
          key={stat.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-200"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {stat.label}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {stat.value}
              </p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat.bgColor} flex items-center justify-center`}>
              <Icon 
                name={stat.icon} 
                size={24} 
                className={stat.color}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;